import produce from 'immer';
import create from 'zustand';
import { urlToSearchCriteria } from './utils';

const { type } = urlToSearchCriteria();
const fundTypes = type ? [type] : [];

const useStore = create(set => ({
  totalResults: 0,
  funds: [],
  companySlug: null,
  assetClasses: [],
  filters: {
    assetClasses: [],
    name: '',
    fundTypes,
  },
  appliedFilters: {
    assetClasses: [],
    fundTypes,
  },
  filterChanged: false,
  sortOrder: 'default',
  sortOrderChanged: false,
  currentView: 'summary',
  fundType: null,
  series: null,
  showFundModal: false,
  currentModalFund: null,
  showFundTypesModal: false,
  showAssetClassFilterHint: false,
  showNameFilter: false,
  searchNoResultsImageUrl: null,
  loadingFunds: false,
  resetFilters: null,
  set: fn => set(produce(fn)),
}));

export default useStore;
